import React from 'react'
import classnames from 'classnames'
import '@/assets/styles/components/tips.scss'
import { connect } from 'react-redux';
import wrong_icon from '@/assets/images/icons/wrong_icon.png'
import warning_icon from '@/assets/images/icons/icon_warning.png'
import success_icon from '@/assets/images/icons/icon_success.png'
import {Icons } from '@/configurations';

class Tips extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  getClassName(){
    const {isSuccess , isWarning} = this.props;
    if(isWarning){
      return 'warning-text';
    }else{
      if(isSuccess){
        return 'success-text';
      }else{
        return 'error-text';
      }
    }
  }

  getIcon(){
    const {isSuccess , isWarning} = this.props;
    if(isWarning){
      return <img src={warning_icon} alt="wrong_icon"/>
    }else{
      if(isSuccess){
        return <Icons.tips_success/>
      }else{
        return <img src={wrong_icon} alt="wrong_icon"/>
      }
    }
  }

  render() {
    const { isSuccess, isNoBgColor, style } = this.props;
    return (
      <div style={style} className={classnames('error-text',this.getClassName(), isNoBgColor && "non-bg-color")}>
        <label>
          {this.getIcon()}
        </label>
        <span>
          {this.props.children}
        </span>
      </div>
    )
  }
}

Tips.defaultProps = {
  isSuccess: false,
  isNoBgColor: false
}

export default connect(
)(Tips)